<template>
  <div class="text-center">
    <div
      id="signin"
      class="container-fluid"
    >
      <form
        @submit.prevent="onSubmit"
        class="form-signin"
        data-ts-url="/auth"
      >
        <h1 class="h3 mt-5 mb-4 font-weight-normal">
          ACCOUNT LOGIN
        </h1>
        <label
          for="email"
          class="sr-only"
        >Email address</label>
        <input
          class="form-control"
          placeholder="Email address"
          required
          autofocus
          type="email"
          id="email"
          name="email"
          v-model="email"
        >
        <label
          for="password"
          class="sr-only"
        >Password</label>
        <input
          class="form-control mb-1"
          placeholder="Password"
          required
          :type="passwordType"
          id="password"
          name="password"
          v-model="password"
        >
        <label
          class="d-block text-left"
        >
          <input
            class="form-control-inline mb-3"
            type="checkbox"
            v-model="showPassword"
            @change="togglePassword"
          > Show Password
        </label>
        <button
          type="submit"
          class="btn btn-primary btn-block"
        >
          Login
        </button>
      </form>
    </div>
    <div class="clearfix" />
  </div>
</template>
<script>
export default {
    data: () => ( {
        email: '',
        password: '',
        showPassword: '',
        passwordType: 'password'
    } ),
    methods: {
        onSubmit() {
            const credentials = {
                email: this.email,
                password: this.password
            };
            this.$store.dispatch( 'login', credentials );
        },
        togglePassword() {
            if ( this.passwordType === 'password' ) {
                this.passwordType = 'text';
            } else {
                this.passwordType = 'password';
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue